class Dialog {
  constructor() {
    this.triggers = document.querySelectorAll('.js-toggle-dialog');
    this.active = false;
  }

  init() {
    return new Promise((resolve) => {
      this.bindListeners();
      this.setProperties();

      resolve();
    });
  }

  setProperties() {
    this.overlay = document.querySelector('.wb-dialog');
    this.close = document.querySelectorAll('.wb-dialog__close');
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-toggle-dialog', _this.openOverlay.bind(_this));
    document.querySelector('body')._addCustomEventListener('click', '.wb-dialog__close', _this.closeOverlay.bind(_this));
    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
    document.addEventListener('_page_loaded', _this.setProperties.bind(_this));
  }


  openOverlay(e) {
    this.refTrigger = e.targetElement;
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });
    const overlayId = this.refTrigger.getAttribute('aria-controls');
    this.overlay = document.querySelector(`#${overlayId}`) || this.overlay || null;
    if (!this.overlay) return;
    this.overlay._show(0.5);
    this.overlay.classList.add('overlay--open');
    this.overlay.querySelector('[aria-selected="true"]')?.focus();
    this.trapFocus = new TrapFocus({ ele: this.overlay, activeClass: 'overlay--open' });
    document.querySelector('html, body').classList.add('overlay--active');
  }

  closeOverlay() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.overlay._hide(0.5).then(() => this.overlay.classList.remove('overlay--open'));
    this.refTrigger.focus();
    this.refTrigger = false;
    document.querySelector('html, body').classList.remove('overlay--active');
  }

  keydownEventListener(e) {
    const _this = this;
    let isOpen = this.overlay?.classList?.contains('overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        _this.closeOverlay();
        break;
    }
  }
}

window.dialog = new Dialog();

(function (window, $) {
  $(document).ready(function () {
    dialog.init();
  });
})(window, jQuery);
